import axios, { getData } from "lib/axios"

export const getQualifications = async () => {
    const response = await axios
        .get(`/recruitment/qualifications`);
    return getData(response);
  };

export const getCourses = async () => {
    const response = await axios
        .get(`/recruitment/courses`);
    return getData(response);
  };

export const getJobBackgrounds = async () => {
    const response = await axios
        .get(`/recruitment/job_backgrounds`);
    return getData(response);
  };

export const getJobLevels = async () => {
    const response = await axios
        .get(`/recruitment/job_levels`);
    return getData(response);
  };
  
export const getSkills = async () => {
    const response = await axios
        .get(`/recruitment/skills`);
    return getData(response);
  };
